import React, {useEffect, useState, memo, useRef} from "react";
import {
  Stack, Button, Paper, Typography, Box, tableCellClasses, Skeleton, CircularProgress
} from '@mui/material'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useNavigate} from 'react-router-dom'

import KeepAlive from 'react-activation'

import {useInfiniteScroll} from "ahooks";
import {getCardApplyList} from '@/services'
import CardImage from "@/pages/cards/components/CardImage";
import dayjs from "dayjs";
import {styled} from "@mui/system";
import RouteConstant from "@/constant/RouteConstant";
import useMobileDetect from "next-device-detection";

import classes from "./index.module.less";
import mobileClasses from "./mobile.module.css";
import LoadMore from "@/components/LoadMore";
import TransItem from "@/components/skeleton/TransItem";
import Empty from "@/components/Empty.tsx";
import PageBack from "@/components/PageBack";
import RpIcon from "@/components/RpIcon";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import {useTranslation} from "react-i18next";
import useRestoreScroll from '@/hook/useRestoreScroll';
import {useKeepAliveContext} from "@hhhgamehhh/keepalive-for-react";

import { PullToRefreshify } from "react-pull-to-refreshify";

function Arrow({ percent }: { percent: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      style={{
        width: 24,
        height: 24,
        transform: `rotate(-${(percent * 180) / 100}deg)`
      }}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
      />
    </svg>
  );
}

const CardApplyOrderList = memo(() => {
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate()
  const ref = useRef(null);
  const detectMobile = useMobileDetect();
  const {t} = useTranslation();
  const getList = async (current = 1) => {
    let res
    try {
      res = await getCardApplyList({
        pageNum: current,
        pageSize
      })
    } catch (e) {

    }

    const result = {
      list: res?.list || [],
      total: res?.total || 0,
      page: current,
    };
    return result;
  }

  const {data, loading, loadMore, loadingMore, noMore, reload, reloadAsync} = useInfiniteScroll((d) => {
    const page = d ? d.page + 1 : 1
    return getList(page);
  }, {
    manual: false,
    target: ref,
    threshold: 0,
    isNoMore: (d) => {
      return (d && d.list.length >= d.total)
    }
  });
  const hasMore = data && data.list.length < data.total;

  const StyledTableHead = styled(TableHead)(({theme}) => {

  })

  const StyledTableHeadRow = styled(TableRow)(({theme}) => {
    return {
      [`& .${tableCellClasses.root}`]: {
        color: theme.palette.secondaryTextColor
      },
    }
  })

  const clearScroll = useRestoreScroll(ref, 400, false)
  const { refresh, destroy } = useKeepAliveContext();

  function renderText(pullStatus, percent) {
    switch (pullStatus) {
      case "pulling":
        return <Arrow percent={percent} />;

      case "canRelease":
        return <Arrow percent={100} />;

      case "refreshing":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <svg
              className="rotating"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              style={{
                width: 18,
                height: 18,
                marginRight: 8
              }}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>

          </div>
        );

      case "complete":
        return "";

      default:
        return "";
    }
  }

  const [refreshing, setRefreshing] = useState(false);

  function handleRefresh() {
    setRefreshing(true);
    reloadAsync().then(() => {
      setRefreshing(false);
    })
    // dispatch(onFocusedCardId(''));
    // setTimeout(() => {
    //
    //   setRefreshing(false);
    // }, 1000);
  }

  return (
    <>
      <PullToRefreshify
        className={classes.pullRefresh}
        // style={{
        //   height: '400px',
        //   // flex: 1,
        //   overflow: 'hidden',
        // }}
        refreshing={refreshing}
        onRefresh={handleRefresh}
        renderText={renderText}
      >
      <Stack sx={{
        // flex: 1,
        // height: '100px',
        width:'100%',
        height: '100%'
      }}>
      <SimpleHeader
        closeButton={
        <RpIcon clickable
                icon="arrow-left"
                onClick={() => {
                  destroy()
                  clearScroll()
                  navigate(-1)
                }}
                />
        }
        title={t("card_application_list")}/>
      <Box className={mobileClasses.root} ref={ref}>
        {loading ? (
          <>
            {
              (new Array(7).fill(0)).map((_,index) => {
                return (
                  <TransItem key={index}/>
                )
              })
            }
          </>
        ) : data?.list.length === 0 ? (
          <Box>
            <Empty text={t('no_data')} />
          </Box>
        ) : <Box >
          <Stack gap={'12px'} sx={{marginTop: '16px'}} className={mobileClasses.list}>
            {
              data?.list.map((item,index) => {
                return (
                  <Stack
                  key={index}
                    onClick={() => {
                      navigate(
                        RouteConstant.CARD_APPLY_ORDER_DETAIL + '?sn=' + item.sn,
                        {state: {...item}}
                      )
                    }}
                    sx={theme => ({
                      backgroundColor: theme.palette.background.card,
                    })}
                    className={mobileClasses.item} direction="row" justifyContent="space-between"
                    alignItems="center">
                    <Stack direction="row" gap={'12px'}>
                      <CardImage cardType={item.cardType} height={39} width={65}/>
                      <Stack>
                        <Typography fontSize={'15px'} fontWeight={500}>{t(`buy_${item.cardType == 1 ? 'virtual' : 'physical'}_card`)}</Typography>
                        <Typography fontSize={'12px'} color={"textTertiary"}>{dayjs(item.createTime).format('D/MM/YYYY HH:mm:ss')}</Typography>
                      </Stack>
                    </Stack>
                    <Stack direction="column" justifyContent="flex-end" alignItems="flex-end">
                      <Typography fontSize={'15px'} fontWeight={500}>{item.bizAmount} USD</Typography>
                      <Typography>{item.last4 ? `\u2022\u2022\u2022\u2022 ${item.last4}` : '\u2022\u2022\u2022\u2022 `\u2022\u2022\u2022\u2022'} </Typography>
                    </Stack>
                  </Stack>

                )
              })
            }
          </Stack>
          <Stack className={classes.loadoMore} direction="row">
            {hasMore && (
              <Box>
                <LoadMore disabled={loadingMore} loading={loadingMore} hasMore={!noMore} onClick={() => {
                  loadMore
                }}/>
              </Box>
            )}
            {!hasMore && <Typography>{t('no_more_data')}</Typography>}
          </Stack>
        </Box>
        }

      </Box>
    </Stack>
      </PullToRefreshify>
    </>
  )
})

export default CardApplyOrderList
